goog.provide('el8.ext.util');

goog.require('el8.service.urls');

el8.ext.util = (function() {

    return {
        validationOpts: function() {
            var that = this;
            return {
                focusCleanup: true,
                invalidHandler: function(form, validator) {
                    // TODO
                },
                highlight: function(element, errorClass) {
                    el8.ext.util.highlightError($(element));
                },
                unhighlight: function(element, errorClass) {
                    el8.ext.util.unhighlightError($(element));
                    $(element).prevAll('.error-msg').empty();
                },
                errorElement: 'div',
                errorClass: 'error-msg el8FieldValidationText el8AlertText',
                errorPlacement: function(error, element) {
                    that.errorPlacementFn($(error), $(element));
                }
            };
        },
        errorPlacementFn: function($error, $element) {
            var name = $element.attr('name');
            $error.attr('data-name', name);
            var $existing = $element.prevAll('.error-msg');
            if ($existing.length) {
                $existing.replaceWith($error); 
            } else {
                $error.insertBefore($element);
            }
        },
        highlightError: function($elt) {
            $elt.addClass('hasError').addClass('has-error');
            $elt.closest('.el8OBTextareaWrap, .el8OBTextareaWrapValidation, .el8Wrap')
                .addClass('hasErrorIcon');
        },
        unhighlightError: function($elt) {
            $elt.removeClass('hasError').removeClass('has-error');
            $elt.closest('.el8OBTextareaWrap').removeClass('hasErrorIcon');
            $elt.closest('.el8OBTextareaWrap, .el8OBTextareaWrapValidation, .el8Wrap')
                .removeClass('hasErrorIcon');
        },
        showError: function(form, container, name, errorMsg) {
            el8.ext.util.highlightError(form.getInputField(name));
            $('.error-msg[data-name="'+name+'"]', container).text(errorMsg);
        },
        clearError: function(form, container, name) {
            el8.ext.util.unhighlightError(form.getInputField(name));
            $('.error-msg[data-name="'+name+'"]', container).empty();
        },
        formValidateEmail: function(form, container, fieldName, emailStr, async) {
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('validEmail'),
                async: async,
                data: {email: emailStr},
                success: function(data) {
                    if (!data['available'] || !data['valid']) {
                        if (!data['valid']) {
                            el8.ext.util.showError(form, container, 
                                fieldName, 'email format is not valid');
                        } else {
                            el8.ext.util.showError(form, container, 
                                fieldName, 'email format is already taken');
                        }
                    } else {
                        el8.ext.util.clearError(form, container, fieldName);
                    }
                }
            });
        }
    };

})();

